import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';

const Section = styled.div`
  padding: 112px 0;
  background-color: ${themeGet('colors.background')};
  @media (max-width: 1280px) {
    padding: 88px 0;
  }
  @media (max-width: 768px) {
    padding: 64px 0;
  }
  .testimonial_area {
    padding-top: 96px;
    @media (max-width: 768px) {
      padding-top: 64px;
    }
  }
`;


export default Section;